export default "__VITE_ASSET__CcqmUvTU__"